window.initProductBundleSlider = function (root) {
  const scope = root || document;
  const slider = scope.querySelector('.product__bundle--slider');
  if (!slider) return;

  setTimeout(function () {
    const viewport = slider.querySelector('.flickity-viewport');
    const cells = slider.querySelectorAll('.flickity-cell');
    if (!cells.length) return;

    let maxHeight = 0;

    cells.forEach(function (cell) {
      cell.style.height = 'auto';
    });

    cells.forEach(function (cell) {
      maxHeight = Math.max(maxHeight, cell.offsetHeight);
    });

    cells.forEach(function (cell) {
      cell.style.height = maxHeight + 'px';
    });

    if (viewport) {
      viewport.style.height = maxHeight + 'px';
    }
  }, 2000);
};

document.addEventListener('DOMContentLoaded', function () {
  window.initProductBundleSlider();
});
